import { gql } from '@apollo/client';
import { PageContentType } from '../../../server/global/enum';

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AggregatedItem = {
  __typename?: 'AggregatedItem';
  key?: Maybe<Scalars['String']>;
};

export type AllNewsResponse = {
  __typename?: 'AllNewsResponse';
  total?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<News>>>;
};

export type AllPropertyUnits = {
  __typename?: 'AllPropertyUnits';
  all?: Maybe<Array<Maybe<Property>>>;
};

export type Bs_BoligsokCriteria = {
  __typename?: 'BS_BoligsokCriteria';
  propertytype?: Maybe<Array<Maybe<Scalars['String']>>>;
  pricefrom?: Maybe<Scalars['Int']>;
  priceto?: Maybe<Scalars['Int']>;
  sizefrom?: Maybe<Scalars['Int']>;
  sizeto?: Maybe<Scalars['Int']>;
  bedroomsfrom?: Maybe<Scalars['Int']>;
  geo?: Maybe<Bs_GeoOutput>;
  active?: Maybe<Scalars['Boolean']>;
};

export type Bs_BoligsokFormInput = {
  coordinates: Bs_Geo;
  propertytype: Scalars['String'];
  price: Bs_Price;
  size: Bs_Size;
  bedroomsfrom: Scalars['Int'];
  contactinfo: Bs_ContactInfo;
  consents: Bs_Consents;
};

export type Bs_BoligsokFormResponse = {
  __typename?: 'BS_BoligsokFormResponse';
  response: Scalars['String'];
  hash: Scalars['String'];
};

export type Bs_BoligsokFormUpdateInput = {
  coordinates: Bs_Geo;
  propertytype: Scalars['String'];
  price: Bs_Price;
  size: Bs_Size;
  bedroomsfrom: Scalars['Int'];
  hash: Scalars['String'];
};

export type Bs_Consents = {
  valuation: Scalars['Boolean'];
};

export type Bs_ContactInfo = {
  name: Scalars['String'];
  zip: Scalars['String'];
  email: Scalars['String'];
  mobile: Scalars['String'];
};

export type Bs_Geo = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  radius: Scalars['Int'];
};

export type Bs_GeoOutput = {
  __typename?: 'BS_GeoOutput';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  radius: Scalars['Int'];
};

export type Bs_MatchingSearchesInput = {
  price?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  propertytype: Scalars['String'];
  lat: Scalars['String'];
  lng: Scalars['String'];
  radius: Scalars['Int'];
};

export type Bs_MatchingSearchesOutput = {
  __typename?: 'BS_MatchingSearchesOutput';
  matches?: Maybe<Scalars['Int']>;
};

export type Bs_Price = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type Bs_Size = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type Bs_TestResult = {
  __typename?: 'BS_TestResult';
  response?: Maybe<Scalars['String']>;
};

export type Bs_Unsubscribe = {
  __typename?: 'BS_Unsubscribe';
  response: Scalars['String'];
};

export type Bid = {
  __typename?: 'Bid';
  url?: Maybe<Scalars['String']>;
};

export type Broker = {
  __typename?: 'Broker';
  id?: Maybe<Scalars['String']>;
  /** Kun tilgjengelig ved henting av eiendom */
  wmId?: Maybe<Scalars['Int']>;
  /** Kun tilgjengelig ved henting av eiendom */
  viewLarge?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  cellphone?: Maybe<Scalars['String']>;
  image?: Maybe<BrokerImage>;
  path?: Maybe<Scalars['String']>;
  helper?: Maybe<Scalars['Boolean']>;
  office?: Maybe<BrokerOffice>;
  showProperties?: Maybe<Scalars['Boolean']>;
  naering?: Maybe<Scalars['Boolean']>;
  /**
   * Dette feltet er kun tilgjengelig sammen med eiendom
   * (1 = vanlig, 2 = ansvarlig)
   */
  type?: Maybe<Scalars['Int']>;
  responsible?: Maybe<Scalars['Boolean']>;
};

export type BrokerFilter = {
  /** Show only project brokers */
  projectOnly?: Maybe<Scalars['Boolean']>;
};

export type BrokerImage = {
  __typename?: 'BrokerImage';
  full?: Maybe<Scalars['String']>;
  relative?: Maybe<Scalars['String']>;
};

export type BrokerInput = {
  id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
};

export type BrokerOffice = {
  __typename?: 'BrokerOffice';
  urltag?: Maybe<Scalars['String']>;
  info?: Maybe<Office>;
};

export type BrokerOffices = {
  __typename?: 'BrokerOffices';
  list?: Maybe<Array<Maybe<Office>>>;
};

export type BrokerPagination = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type BrokerShowProperties = {
  __typename?: 'BrokerShowProperties';
  show?: Maybe<Scalars['Boolean']>;
};

export type BrokersInput = {
  id?: Maybe<Scalars['Int']>;
  urltag?: Maybe<Scalars['String']>;
  pagination?: Maybe<BrokerPagination>;
};

export type BrokersList = {
  __typename?: 'BrokersList';
  total?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<SingleBroker>>>;
};

export type BrukerSamtykker = {
  navn?: Maybe<Scalars['String']>;
  epost?: Maybe<Scalars['String']>;
  telefon?: Maybe<Scalars['String']>;
  tjeneste?: Maybe<Scalars['Int']>;
  samtykker?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type Consents = {
  /** REELTIME - Del med utbygger - Og dele min informasjon med utbygger */
  delmedutbygger?: Maybe<Scalars['Boolean']>;
  /** WEBMEGLER - Budvarsel-SMS - Jeg ønsker budvarsel på SMS (2901339) */
  budvarsel?: Maybe<Scalars['Boolean']>;
  /** WEBMEGLER - Oppdateringer - Jeg ønsker å bli holdt oppdatert om eiendommen på telefon, sms eller epost (2901563) */
  oppdateringer?: Maybe<Scalars['Boolean']>;
  /** WEBMEGLER - Tips om likn. eiend. - Jeg ønsker tips om liknende eiendommer (2901340) */
  tipsomliknende?: Maybe<Scalars['Boolean']>;
  /** WEBMEGLER - Generell markedsføring - Jeg ønsker å motta eiendomsrelatert informasjon (2901341) */
  generellmarkedsforing?: Maybe<Scalars['Boolean']>;
  /**
   * WEBMEGLER - Skal selge bolig - Jeg skal selge bolig og ønsker kontakt med PrivatMegleren (2901342)
   * Denne tolkes også som verdivurdering hos Reeltime og sendes også til Tipsportalen
   */
  skalselgebolig?: Maybe<Scalars['Boolean']>;
  /**
   * WEBMEGLER - Finansiering - Jeg ønsker tilbud på finansiering fra Nordea og
   * ønsker å bli kontaktet pr. telefon eller e-post (2901343)
   * Denne tolkes som finansiering hos Reeltime og sendes også til Tipsportalen
   */
  finansiering?: Maybe<Scalars['Boolean']>;
  /** WEBMEGLER - Forsikring - Jeg ønsker tilbud på forsikring (2901344) */
  forsikring?: Maybe<Scalars['Boolean']>;
  /**
   * WEBMEGLER - Kjøp av bolig? - Jeg ønsker å bli kontaktet pr. telefon eller
   * epost i forbindelse med produktet PrivatMegleren KJØP (3000838)
   */
  kjop?: Maybe<Scalars['Boolean']>;
  /**
   * RT TIL WEBMEGLER - Tips om lignende eiendommer og Generell Markedsføring - om
   * lignende eiendommer som kommer for salg og annen boligrelatert informasjon
   * (2901340, 2901341)
   */
  tipsomlignendeoggenerellmarkedsforing?: Maybe<Scalars['Boolean']>;
};

export type ContactInput = {
  pageType?: Maybe<ContactPageType>;
  path?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
};

export enum ContactPageType {
  Office = 'OFFICE',
  Broker = 'BROKER'
}

export type ContactResponse = {
  __typename?: 'ContactResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
};

export type Cost = {
  __typename?: 'Cost';
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CountyItem = {
  name?: Maybe<Scalars['String']>;
  municipalityArea?: Maybe<Array<Maybe<MunicipalityAreaItem>>>;
};

export type CustomResponse = {
  __typename?: 'CustomResponse';
  success?: Maybe<Scalars['Boolean']>;
};


export type DemographItem = {
  __typename?: 'DemographItem';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DiggerData = {
  __typename?: 'DiggerData';
  id?: Maybe<Scalars['String']>;
  sguid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
};

export type DiggerId = {
  type?: Maybe<FormType>;
  id?: Maybe<Scalars['Int']>;
  diggerId?: Maybe<Scalars['String']>;
};

export type DiggerSavedResponse = {
  __typename?: 'DiggerSavedResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type District = {
  __typename?: 'District';
  zip?: Maybe<Scalars['String']>;
};

/** Defining type of content by wm_parent_node column */
export enum DocType {
  All = 'all',
  Vedleggsalgsoppgave = 'vedleggsalgsoppgave',
  Dsvedlegg = 'dsvedlegg'
}

export type Document = {
  __typename?: 'Document';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['String']>;
};

export type EnergyLabel = {
  __typename?: 'EnergyLabel';
  color?: Maybe<Scalars['String']>;
  letter?: Maybe<Scalars['String']>;
};

export type Extra = {
  __typename?: 'Extra';
  flerfamilie?: Maybe<PeopleDemograph>;
  parmedbarn?: Maybe<PeopleDemograph>;
  parutenbarn?: Maybe<PeopleDemograph>;
  ensligmedbarn?: Maybe<PeopleDemograph>;
  ensligutenbarn?: Maybe<PeopleDemograph>;
  barn?: Maybe<PeopleDemograph>;
  ungdom?: Maybe<PeopleDemograph>;
  ung?: Maybe<PeopleDemograph>;
  voksen?: Maybe<PeopleDemograph>;
  eldre?: Maybe<PeopleDemograph>;
  antallPersoner?: Maybe<PeopleCountDemograph>;
  antallHusholdninger?: Maybe<PeopleCountDemograph>;
};

export type Filter = {
  property?: Maybe<PropertyFilter>;
  office?: Maybe<OfficeFilter>;
  broker?: Maybe<BrokerFilter>;
};

export type FinancingResponse = {
  __typename?: 'FinancingResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type FinnKriterier = {
  __typename?: 'FinnKriterier';
  id_typer?: Maybe<Scalars['Int']>;
  navn?: Maybe<Scalars['String']>;
  iadnavn?: Maybe<Scalars['String']>;
};

export enum FormType {
  /** Registrering av verdivurderinger */
  Verdivurdering = 'VERDIVURDERING',
  /** Registrering av interessenter */
  Interessent = 'INTERESSENT',
  /** Registrering av finansiering */
  Finansiering = 'FINANSIERING'
}

export type GetAllNewsInput = {
  type?: Maybe<NewsType>;
  urltag: Scalars['String'];
  page: Scalars['Int'];
  limit?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Int']>;
};

export type GetPositionInput = {
  slug?: Maybe<Scalars['String']>;
};

export type GetPositionResponse = {
  __typename?: 'GetPositionResponse';
  total?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Position>>>;
};

export type GetPositionsInput = {
  pagination: PositionPagination;
  urltag?: Maybe<Scalars['String']>;
};

export type GetReferenceResponse = {
  __typename?: 'GetReferenceResponse';
  total?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Reference>>>;
};

export type GetReferencesInput = {
  type: ReferenceType;
  id?: Maybe<Scalars['Int']>;
  urltag?: Maybe<Scalars['String']>;
  pagination: ReferencesPagination;
};

export type GetSingleNewsInput = {
  type?: Maybe<NewsType>;
  category?: Maybe<Scalars['Int']>;
  urltag: Scalars['String'];
  slug: Scalars['String'];
};

export enum IdentifierType {
  OfficeId = 'OFFICE_ID',
  OfficeUrltag = 'OFFICE_URLTAG',
  BrokerPath = 'BROKER_PATH',
  BrokerId = 'BROKER_ID'
}

export type Image = {
  __typename?: 'Image';
  id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  ai_label?: Maybe<Scalars['String']>;
  ai_percent?: Maybe<Scalars['String']>;
};

export enum ImageSize {
  /** thumbnail */
  Small = 'small',
  /** Lite bilde */
  Medium = 'medium',
  /** Stort bilde */
  Large = 'large',
  /** Orginal bilde */
  Original = 'original'
}

export type InsertPropertyHighLighted = {
  urltag?: Maybe<Scalars['String']>;
  oppdragsnummer?: Maybe<Scalars['String']>;
};

export type InterestedDataResponse = {
  __typename?: 'InterestedDataResponse';
  ids?: Maybe<Array<Maybe<InterestedTypeItem>>>;
};

export type InterestedResponse = {
  __typename?: 'InterestedResponse';
  success?: Maybe<Scalars['Boolean']>;
  data?: Maybe<InterestedDataResponse>;
};

export type InterestedTypeItem = {
  __typename?: 'InterestedTypeItem';
  type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  data?: Maybe<DiggerData>;
};


export type Kriterier = {
  __typename?: 'Kriterier';
  wmMatchekriterier?: Maybe<Array<Maybe<WmKriterier>>>;
  finnMatchekriterier?: Maybe<Array<Maybe<FinnKriterier>>>;
};

export enum LandingPageType {
  Home = 'HOME',
  Valuation = 'VALUATION',
  Contact = 'CONTACT',
  Cookie = 'COOKIE'
}

export type Landingpages = {
  officeId?: Maybe<Scalars['Int']>;
  urltag?: Maybe<Scalars['String']>;
  pageType: LandingPageType;
};

export type LandingpagesResponse = {
  __typename?: 'LandingpagesResponse';
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
};

export type LeadInput = {
  leadType: LeadType;
  pageType?: Maybe<PageType>;
  mailType?: Maybe<Scalars['Int']>;
  /**
   * urltag (kontor), sguid (objekt), path (megler)
   * Dersom generell skal identifier ikke være satt.
   */
  identifierType?: Maybe<IdentifierType>;
  identifier?: Maybe<Scalars['String']>;
  diggerId?: Maybe<Scalars['String']>;
  wmId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  referer?: Maybe<Scalars['String']>;
  consents?: Maybe<Consents>;
  listType?: Maybe<Scalars['String']>;
  notify?: Maybe<LeadNotify>;
  json?: Maybe<Scalars['JSON']>;
};

export type LeadNotify = {
  mail?: Maybe<LeadNotifyMail>;
  autoreply?: Maybe<Scalars['Boolean']>;
};

export type LeadNotifyMail = {
  from: Scalars['String'];
  to: Scalars['String'];
  cc?: Maybe<Scalars['String']>;
  bcc?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type LeadResponse = {
  __typename?: 'LeadResponse';
  financing?: Maybe<FinancingResponse>;
  interested?: Maybe<InterestedResponse>;
  valuation?: Maybe<ValuationResponse>;
  contact?: Maybe<ContactResponse>;
  mail?: Maybe<MailResponse>;
  soldprice?: Maybe<SoldpriceResponse>;
  custom?: Maybe<CustomResponse>;
};

export enum LeadType {
  Verdivurdering = 'VERDIVURDERING',
  Interessent = 'INTERESSENT',
  Finansiering = 'FINANSIERING',
  Kontakt = 'KONTAKT',
  Epost = 'EPOST',
  Custom = 'CUSTOM',
  Soldprice = 'SOLDPRICE'
}

export type Location = {
  __typename?: 'Location';
  coordinates?: Maybe<Coordinates>;
  municipality?: Maybe<Scalars['String']>;
  municipalityArea?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  searchLocation?: Maybe<Scalars['String']>;
};

export type MailResponse = {
  __typename?: 'MailResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Matrikkel = {
  __typename?: 'Matrikkel';
  snr?: Maybe<Scalars['Int']>;
  bnr?: Maybe<Scalars['Int']>;
  knr?: Maybe<Scalars['Int']>;
  fnr?: Maybe<Scalars['Int']>;
  gnr?: Maybe<Scalars['Int']>;
  /** Kun tilgjengelig dersom underenhet */
  unit?: Maybe<Scalars['String']>;
};

export type Media = {
  __typename?: 'Media';
  url?: Maybe<Scalars['String']>;
};

export type Menu = {
  __typename?: 'Menu';
  menu?: Maybe<Array<Maybe<MenuElements>>>;
  nybyggmenu?: Maybe<Array<Maybe<MenuElements>>>;
  submenu?: Maybe<Array<Maybe<MenuElements>>>;
};

export type MenuElements = {
  __typename?: 'MenuElements';
  name?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  subMenu?: Maybe<Array<Maybe<MenuElements>>>;
};

export type MunicipalityAreaItem = {
  name?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addSamtykke?: Maybe<StandardResponse>;
  registrerBrukerSamtykke?: Maybe<StandardResponse>;
  boligsokform?: Maybe<Bs_BoligsokFormResponse>;
  updateBoligsokform?: Maybe<Bs_BoligsokFormResponse>;
  unsubscribe?: Maybe<Bs_Unsubscribe>;
  registerBoligsokWithId?: Maybe<Bs_BoligsokFormResponse>;
  insertPropertyHighLighted?: Maybe<Scalars['Boolean']>;
  updateNews?: Maybe<UpdateNewsResponse>;
  deleteNews?: Maybe<UpdateNewsResponse>;
  lead?: Maybe<LeadResponse>;
  saveDiggerId?: Maybe<DiggerSavedResponse>;
};


export type MutationAddSamtykkeArgs = {
  input: SamtykkeInput;
};


export type MutationRegistrerBrukerSamtykkeArgs = {
  input: BrukerSamtykker;
};


export type MutationBoligsokformArgs = {
  boligsokFormInput?: Maybe<Bs_BoligsokFormInput>;
};


export type MutationUpdateBoligsokformArgs = {
  boligsokFormInput?: Maybe<Bs_BoligsokFormUpdateInput>;
};


export type MutationUnsubscribeArgs = {
  hash?: Maybe<Scalars['String']>;
};


export type MutationRegisterBoligsokWithIdArgs = {
  id?: Maybe<Scalars['String']>;
  contactinfo?: Maybe<Bs_ContactInfo>;
};


export type MutationInsertPropertyHighLightedArgs = {
  input: InsertPropertyHighLighted;
};


export type MutationUpdateNewsArgs = {
  input: NewsInput;
};


export type MutationDeleteNewsArgs = {
  id: Scalars['Int'];
};


export type MutationLeadArgs = {
  input: LeadInput;
};


export type MutationSaveDiggerIdArgs = {
  input: SaveDiggerInput;
};

export type Neighborhood = {
  __typename?: 'Neighborhood';
  areas?: Maybe<NeighborhoodAreas>;
  demograph?: Maybe<NeighborhoodDemograph>;
  neighborhood?: Maybe<NeighborhoodInfo>;
  places?: Maybe<NeighborhoodPlace>;
  extra?: Maybe<Extra>;
};

export type NeighborhoodAreas = {
  __typename?: 'NeighborhoodAreas';
  grunnkrets?: Maybe<Scalars['String']>;
  kommune?: Maybe<Scalars['String']>;
  norge?: Maybe<Scalars['String']>;
};

export type NeighborhoodDemograph = {
  __typename?: 'NeighborhoodDemograph';
  people?: Maybe<Array<Maybe<DemographItem>>>;
  property?: Maybe<Array<Maybe<DemographItem>>>;
};

export type NeighborhoodInfo = {
  __typename?: 'NeighborhoodInfo';
  recommendedFor?: Maybe<Array<Maybe<NeighborhoodInfoItem>>>;
  transport?: Maybe<Array<Maybe<NeighborhoodInfoItem>>>;
  ratings?: Maybe<NeighborhoodRatingItems>;
};

export type NeighborhoodInfoItem = {
  __typename?: 'NeighborhoodInfoItem';
  name?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
};

export type NeighborhoodPlace = {
  __typename?: 'NeighborhoodPlace';
  nearby?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
  transport?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
  sport?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
  schools?: Maybe<Array<Maybe<NeighborhoodPlaceItemSchool>>>;
  kindergarten?: Maybe<Array<Maybe<NeighborhoodPlaceItemSchool>>>;
  goodsAndServices?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
  higherEducation?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
};

export type NeighborhoodPlaceDistance = {
  __typename?: 'NeighborhoodPlaceDistance';
  selected?: Maybe<Scalars['String']>;
  air?: Maybe<Scalars['Float']>;
  drive?: Maybe<Scalars['Float']>;
  walk?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
};

export type NeighborhoodPlaceDuration = {
  __typename?: 'NeighborhoodPlaceDuration';
  walk?: Maybe<Scalars['Float']>;
  drive?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
};

export type NeighborhoodPlaceItem = {
  __typename?: 'NeighborhoodPlaceItem';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Coordinates>;
  distances?: Maybe<NeighborhoodPlaceDistance>;
  duration?: Maybe<NeighborhoodPlaceDuration>;
};

export type NeighborhoodPlaceItemSchool = {
  __typename?: 'NeighborhoodPlaceItemSchool';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Coordinates>;
  duration?: Maybe<NeighborhoodPlaceDuration>;
  distances?: Maybe<NeighborhoodPlaceDistance>;
  classes?: Maybe<Scalars['String']>;
  students?: Maybe<Scalars['String']>;
};

export type NeighborhoodRatingItem = {
  __typename?: 'NeighborhoodRatingItem';
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Float']>;
  averageCity?: Maybe<Scalars['String']>;
  question?: Maybe<NeighborhoodRatingQuestion>;
};

export type NeighborhoodRatingItems = {
  __typename?: 'NeighborhoodRatingItems';
  trygghet?: Maybe<NeighborhoodRatingItem>;
  naboskapet?: Maybe<NeighborhoodRatingItem>;
  kvalitetskoler?: Maybe<NeighborhoodRatingItem>;
  tryggetderbarnaferdes?: Maybe<NeighborhoodRatingItem>;
  stoynivaa?: Maybe<NeighborhoodRatingItem>;
  vedlikeholdhager?: Maybe<NeighborhoodRatingItem>;
  kollektivtilbud?: Maybe<NeighborhoodRatingItem>;
  trafikk?: Maybe<NeighborhoodRatingItem>;
  turmuligheter?: Maybe<NeighborhoodRatingItem>;
  aktiviteter?: Maybe<NeighborhoodRatingItem>;
  shopping?: Maybe<NeighborhoodRatingItem>;
};

export type NeighborhoodRatingQuestion = {
  __typename?: 'NeighborhoodRatingQuestion';
  text?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<NeighborhoodRatingQuestionOption>>>;
};

export type NeighborhoodRatingQuestionOption = {
  __typename?: 'NeighborhoodRatingQuestionOption';
  text?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
};

export type NeighborhoodRatingScore = {
  __typename?: 'NeighborhoodRatingScore';
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Float']>;
  averageCity?: Maybe<Scalars['String']>;
};

export type NeighborhoodSchoolInfo = {
  __typename?: 'NeighborhoodSchoolInfo';
  students?: Maybe<Scalars['String']>;
  classes?: Maybe<Scalars['String']>;
};

export type NeighborhoodUrl = {
  __typename?: 'NeighborhoodUrl';
  url?: Maybe<Scalars['String']>;
};

export type News = {
  __typename?: 'News';
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  imageCategory?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  ingress?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type NewsInput = {
  id?: Maybe<Scalars['Int']>;
  image: Scalars['String'];
  title: Scalars['String'];
  ingress: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  urltag: Scalars['String'];
  category: Scalars['Int'];
  publish?: Maybe<Scalars['Boolean']>;
  externalUrl: Maybe<Scalars['String']>;
};

export enum NewsType {
  Nybyggportal = 'NYBYGGPORTAL'
}

export enum NewsSearchTypes {
  NYBYGGALLNEWS = 'NYBYGGALLNEWS',
  NYBYGGFRONTPAGE = 'NYBYGGFRONTPAGE'
}

export type ObjectTypeAggregated = {
  key?: Maybe<Scalars['String']>;
};

export type Office = {
  __typename?: 'Office';
  id?: Maybe<Scalars['String']>;
  wmId?: Maybe<Scalars['String']>;
  orgnumber?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  postaddress?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  urltag?: Maybe<Scalars['String']>;
  brokers?: Maybe<OfficeBrokers>;
  coordinates?: Maybe<Coordinates>;
  seo?: Maybe<OfficeSeo>;
  about?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  valuationText?: Maybe<Scalars['String']>;
  pricelist?: Maybe<Scalars['String']>;
  districts?: Maybe<OfficeDistricts>;
  hasSoldPrice?: Maybe<Scalars['Boolean']>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  referencesText?: Maybe<Scalars['String']>;
  referencesFormText?: Maybe<Scalars['String']>;
  news?: Maybe<OfficeNews>;
  zipCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  naering?: Maybe<Scalars['Boolean']>;
  newDevelopment?: Maybe<OfficeNewDevelopment>;
  newDevelopmentServices?: Maybe<OfficeNewDevelopmentServices>;
  newDevelopmentCustomers?: Maybe<OfficeNewDevelopmentCustomers>;
  /** Broker title on each office */
  title?: Maybe<Scalars['String']>;
  brokerShowProperties?: Maybe<Scalars['Boolean']>;
  /** Only available in search geolocation distance */
  distance?: Maybe<OfficeDistance>;
};

export type OfficeBrokers = {
  __typename?: 'OfficeBrokers';
  list?: Maybe<Array<Maybe<Broker>>>;
};

export type OfficeCustomers = {
  urltag?: Maybe<Scalars['String']>;
};

export type OfficeDistance = {
  __typename?: 'OfficeDistance';
  value?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
};

export type OfficeDistricts = {
  __typename?: 'OfficeDistricts';
  list?: Maybe<Array<Maybe<District>>>;
};

export type OfficeFilter = {
  /** Show all offices */
  showAll?: Maybe<Scalars['Boolean']>;
  /** Show only project offices */
  projectOnly?: Maybe<Scalars['Boolean']>;
  /** Filter offices by connected zipcodes. */
  zip?: Maybe<OfficeZip>;
  geolocation?: Maybe<OfficeGeolocation>;
};

export type OfficeGeolocation = {
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  unit?: Maybe<PropertyGeolocationUnit>;
};

export type OfficeInput = {
  id?: Maybe<Scalars['Int']>;
  urltag?: Maybe<Scalars['String']>;
  type?: Maybe<OfficeType>;
};

export type OfficeNewCustomerItem = {
  __typename?: 'OfficeNewCustomerItem';
  id?: Maybe<Scalars['Int']>;
  img?: Maybe<Scalars['String']>;
  imgCategory?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type OfficeNewDev = {
  __typename?: 'OfficeNewDev';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  titleBroker?: Maybe<Scalars['String']>;
  descriptionBroker?: Maybe<Scalars['String']>;
  titleService?: Maybe<Scalars['String']>;
  ingressService?: Maybe<Scalars['String']>;
  contentService?: Maybe<Scalars['String']>;
  descriptionBuy?: Maybe<Scalars['String']>;
  descriptionNews?: Maybe<Scalars['String']>;
  frontCoverImage?: Maybe<Scalars['String']>;
  customersCoverImage?: Maybe<Scalars['String']>;
  servicesCoverImage?: Maybe<Scalars['String']>;
  frontpage?: Maybe<OfficeNewDevInfo>;
  contact?: Maybe<OfficeNewDevInfo>;
  broker?: Maybe<OfficeNewDevInfo>;
  customer?: Maybe<OfficeNewDevInfo>;
  news?: Maybe<OfficeNewDevInfo>;
  buy?: Maybe<OfficeNewDevInfo>;
  service?: Maybe<OfficeNewDevInfo>;
};

export type OfficeNewDevInfo = {
  __typename?: 'OfficeNewDevInfo';
  title?: Maybe<Scalars['String']>;
  ingress?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imageList?: Maybe<Array<Maybe<OfficeNewDevInfoImage>>>;
}

export type OfficeNewDevInfoImage = {
  __typename?: 'OfficeNewDevInfoImage';
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
}

export type OfficeNewDevelopment = {
  __typename?: 'OfficeNewDevelopment';
  info?: Maybe<OfficeNewDev>;
};

export type OfficeNewDevelopmentCustomers = {
  __typename?: 'OfficeNewDevelopmentCustomers';
  list?: Maybe<Array<Maybe<OfficeNewCustomerItem>>>;
};

export type OfficeNewDevelopmentServiceItem = {
  __typename?: 'OfficeNewDevelopmentServiceItem';
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  imgCategory?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type OfficeNewDevelopmentServices = {
  __typename?: 'OfficeNewDevelopmentServices';
  list?: Maybe<Array<Maybe<OfficeNewDevelopmentServiceItem>>>;
};

export type OfficeNews = {
  __typename?: 'OfficeNews';
  hasNews?: Maybe<Scalars['Boolean']>;
};

export type OfficePagination = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type OfficeResponse = {
  __typename?: 'OfficeResponse';
  total?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Office>>>;
};

export type OfficeSeo = {
  __typename?: 'OfficeSeo';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export enum OfficeType {
  Nybygg = 'NYBYGG'
}

export type OfficeZip = {
  value?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  unit?: Maybe<PropertyGeolocationUnit>;
};

export type OfficesInput = {
  pagination?: Maybe<OfficePagination>;
};

export enum PageType {
  Generell = 'GENERELL',
  Objekt = 'OBJEKT',
  Megler = 'MEGLER',
  Kontor = 'KONTOR',
  Kampanje = 'KAMPANJE',
  Visningspaamelding = 'VISNINGSPAAMELDING'
}

export type ParkingElement = {
  __typename?: 'ParkingElement';
  id?: Maybe<Scalars['Int']>;
  benevnelse?: Maybe<Scalars['String']>;
  type_salgparkering?: Maybe<Scalars['String']>;
};

export type PeopleCountDemograph = {
  __typename?: 'PeopleCountDemograph';
  label?: Maybe<Scalars['String']>;
  grunnkrets?: Maybe<PeopleDemographSubWithValue>;
  kommune?: Maybe<PeopleDemographSubWithValue>;
  norge?: Maybe<PeopleDemographSubWithValue>;
};

export type PeopleDemograph = {
  __typename?: 'PeopleDemograph';
  label?: Maybe<Scalars['String']>;
  grunnkrets?: Maybe<PeopleDemographSub>;
  kommune?: Maybe<PeopleDemographSub>;
  norge?: Maybe<PeopleDemographSub>;
};

export type PeopleDemographSub = {
  __typename?: 'PeopleDemographSub';
  label?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
};

export type PeopleDemographSubWithValue = {
  __typename?: 'PeopleDemographSubWithValue';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Plot = {
  __typename?: 'Plot';
  /** Størrelse i m2 */
  size?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['String']>;
};

export type Position = {
  __typename?: 'Position';
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  ingress?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  office?: Maybe<PositionOffice>;
};

export type PositionOffice = {
  __typename?: 'PositionOffice';
  name?: Maybe<Scalars['String']>;
  urltag?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
};

export type PositionPagination = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type Price = {
  __typename?: 'Price';
  price?: Maybe<Scalars['Float']>;
  priceTo?: Maybe<Scalars['Float']>;
  customPriceFrom?: Maybe<Scalars['Float']>;
  customPriceTo?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalPriceText?: Maybe<Scalars['String']>;
  totalWithCosts?: Maybe<Scalars['Float']>;
  totalPriceExCosts?: Maybe<Scalars['Float']>;
  totalCosts?: Maybe<Scalars['Float']>;
  costs?: Maybe<Array<Maybe<Cost>>>;
  commonExpenses?: Maybe<Scalars['Float']>;
  commonCosts?: Maybe<Scalars['Float']>;
  commonShareDebt?: Maybe<Scalars['Float']>;
  commonShareDebtTo?: Maybe<Scalars['Float']>;
  commonCostsPeriode?: Maybe<Scalars['String']>;
  taxValue?: Maybe<Scalars['Float']>;
};

export type Properties = {
  __typename?: 'Properties';
  total?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Property>>>;
};

export type PropertiesInput = {
  sold?: Maybe<Scalars['Boolean']>;
  pagination?: Maybe<PropertyPagination>;
  broker?: Maybe<PropertiesInputBroker>;
  office?: Maybe<PropertiesInputOffice>;
  saleType?: Maybe<Array<Maybe<PropertySaleType>>>;
};

export type PropertiesInputBroker = {
  id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
};

export type PropertiesInputOffice = {
  id?: Maybe<Scalars['Int']>;
  urltag?: Maybe<Scalars['String']>;
  urltagArr?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Property = {
  __typename?: 'Property';
  preview?: Maybe<Scalars['Boolean']>;
  previewUpdated?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  wmId?: Maybe<Scalars['String']>;
  id_oppdrag_prosjekt?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  hovedoppdrag?: Maybe<Scalars['Int']>;
  /** Hent ut id til hovedoppdrag på underenheter */
  hovedoppdragId?: Maybe<PropertyHovedoppdrag>;
  zip?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  /** Prosjekt i webmegler_object_cache */
  title?: Maybe<Scalars['String']>;
  /** Overskrift i webmegler_object_cache */
  description?: Maybe<Scalars['String']>;
  freetext?: Maybe<PropertyFreeText>;
  /**
   * Type oppdrag
   * (1 = nybygg, 2 = brukt og 3 = fritid)
   */
  permalink?: Maybe<Scalars['String']>;
  assignmentType?: Maybe<Scalars['String']>;
  ownerType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  naering?: Maybe<Scalars['Boolean']>;
  typeNumber?: Maybe<Scalars['Int']>;
  buildYear?: Maybe<Scalars['String']>;
  rooms?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Scalars['Int']>;
  floor?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Boolean']>;
  bid?: Maybe<PropertyBid>;
  area?: Maybe<PropertyArea>;
  plot?: Maybe<PropertyPlot>;
  price?: Maybe<PropertyPrice>;
  viewings?: Maybe<PropertyViewings>;
  units?: Maybe<PropertyUnits>;
  location?: Maybe<Location>;
  brokers?: Maybe<PropertyAgents>;
  images?: Maybe<PropertyImages>;
  environment?: Maybe<PropertyEnvironment>;
  salgsoppgaveArkiv?: Maybe<PropertySalgsoppgaveArkiv>;
  matrikkel?: Maybe<PropertyMatrikkel>;
  neighborhood?: Maybe<PropertyNeighborhood>;
  documents?: Maybe<PropertyDocuments>;
  allDocuments?: Maybe<PropertyAllDocuments>;
  links?: Maybe<PropertyLinks>;
  office?: Maybe<PropertyOffice>;
  checklistpoints?: Maybe<PropertyChecklistPoints>;
  video?: Maybe<PropertyVideo>;
  viewing3d?: Maybe<Property3dViewing>;
  nybygg?: Maybe<PropertyNybygg>;
  parking?: Maybe<PropertyParking>;
  matchekriterier?: Maybe<PropertyMatchekriterier>;
  prospect?: Maybe<PropertyProspect>;
  projectLogos?: Maybe<PropertyProjectLogos>;
  created?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['String']>;
  reserved?: Maybe<Scalars['Boolean']>;
  /** Markedsføringsklart */
  highlighted?: Maybe<Array<Maybe<PropertyHighlighted>>>;
  accepted?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedDate?: Maybe<Scalars['String']>;
};

export type Property3dViewing = {
  __typename?: 'Property3dViewing';
  info?: Maybe<Media>;
};

export type PropertyAgents = {
  __typename?: 'PropertyAgents';
  responsible?: Maybe<Broker>;
  list?: Maybe<Array<Maybe<Broker>>>;
};

export type PropertyAggregationType = {
  __typename?: 'PropertyAggregationType';
  key?: Maybe<Scalars['String']>;
  doc_count?: Maybe<Scalars['Int']>;
};

export type PropertyAggregations = {
  __typename?: 'PropertyAggregations';
  propertyTypes?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  assignmentTypes?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  sold?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  counties?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  municipalities?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  municipalityAreas?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  places?: Maybe<Array<Maybe<PropertyAggregationType>>>;
};

export type PropertyAllDocuments = {
  __typename?: 'PropertyAllDocuments';
  list?: Maybe<Array<Maybe<Document>>>;
};

export type PropertyArea = {
  __typename?: 'PropertyArea';
  /** Primærrom */
  prom?: Maybe<Scalars['String']>;
  /** Primærrom til */
  promTo?: Maybe<Scalars['String']>;
  /** Bruksareal */
  bra?: Maybe<Scalars['String']>;
  /** Bruksareal til */
  braTo?: Maybe<Scalars['String']>;
  /** Bruttoareal */
  bta?: Maybe<Scalars['String']>;
  /** Bruttoareal til */
  btaTo?: Maybe<Scalars['String']>;
};

export enum PropertyAttachmentType {
  VedleggSalgsoppgave = 'vedlegg_salgsoppgave',
  DsVedlegg = 'ds_vedlegg'
}

export type PropertyBid = {
  __typename?: 'PropertyBid';
  link?: Maybe<Bid>;
};

export type PropertyChecklistPoints = {
  __typename?: 'PropertyChecklistPoints';
  info?: Maybe<PropertyChecklistPointsInfo>;
};

export type PropertyChecklistPointsInfo = {
  __typename?: 'PropertyChecklistPointsInfo';
  pmExclusive?: Maybe<Scalars['Boolean']>;
  useScaledVersion?: Maybe<Scalars['Boolean']>;
  teaser?: Maybe<Scalars['Boolean']>;
  dobbeltBoligforsikring?: Maybe<Scalars['Boolean']>;
};

export type PropertyDocuments = {
  __typename?: 'PropertyDocuments';
  list?: Maybe<Array<Maybe<Document>>>;
};

export type PropertyEnvironment = {
  __typename?: 'PropertyEnvironment';
  energyLabel?: Maybe<EnergyLabel>;
};

export type PropertyFilter = {
  /**
   * Sett til true dersom du kun ønsker å vise eiendommer
   * som har PrivatMegleren Eksklusiv, og sett til false dersom
   * du ikke ønsker Eksklusive eiendommer. Dersom ikke definert vil
   * den ikke ta hensyn til dette.
   */
  exclusive?: Maybe<Scalars['Boolean']>;
  geolocation?: Maybe<PropertyGeolocation>;
  available?: Maybe<Scalars['Boolean']>;
  sold?: Maybe<Scalars['Boolean']>;
  bedrooms?: Maybe<Scalars['Int']>;
  location?: Maybe<Array<Maybe<PropertySearchLocationItem>>>;
  subLocations?: Maybe<Array<Maybe<PropertySearchSubLocationItem>>>;
  objectType?: Maybe<PropertyFilterObjectType>;
  objectTypeAggregated?: Maybe<PropertyFilterObjectTypeAggregated>;
  saleType?: Maybe<Array<Maybe<PropertySaleType>>>;
  price?: Maybe<PropertyFilterPrice>;
  size?: Maybe<PropertyFilterSize>;
  sort?: Maybe<PropertySortByType>;
  brokerId?: Maybe<Scalars['Int']>;
  officeIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  brokerIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  urltag?: Maybe<Scalars['String']>;
  urltagArr?: Maybe<Array<Maybe<Scalars['String']>>>;
  highlighted?: Maybe<Scalars['Boolean']>;
  includeAccepted?: Maybe<Scalars['Boolean']>;
};

export type PropertyFilterObjectType = {
  leilighet?: Maybe<Scalars['Boolean']>;
  enebolig?: Maybe<Scalars['Boolean']>;
  tomannsbolig?: Maybe<Scalars['Boolean']>;
  rekkehus?: Maybe<Scalars['Boolean']>;
  gaardsbruk?: Maybe<Scalars['Boolean']>;
  bygaard?: Maybe<Scalars['Boolean']>;
  romibofelleskap?: Maybe<Scalars['Boolean']>;
  hybel?: Maybe<Scalars['Boolean']>;
  garasjeparkering?: Maybe<Scalars['Boolean']>;
  hytte?: Maybe<Scalars['Boolean']>;
  annet?: Maybe<Scalars['Boolean']>;
  fritid?: Maybe<Scalars['Boolean']>;
  tomter?: Maybe<Scalars['Boolean']>;
  hyttetomt?: Maybe<Scalars['Boolean']>;
  produksjonindustri?: Maybe<Scalars['Boolean']>;
};

export type PropertyFilterObjectTypeAggregated = {
  types?: Maybe<Array<Maybe<ObjectTypeAggregated>>>;
};

export type PropertyFilterPrice = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type PropertyFilterSize = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type PropertyFreeText = {
  __typename?: 'PropertyFreeText';
  list?: Maybe<PropertyFreeTextType>;
};

export type PropertyFreeTextItem = {
  __typename?: 'PropertyFreeTextItem';
  heading?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  groupname?: Maybe<Scalars['String']>;
};

export type PropertyFreeTextType = {
  __typename?: 'PropertyFreeTextType';
  all?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  finnLocalArea?: Maybe<Scalars['String']>;
  keyInformation?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  cooperatives?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  commonAreaAndGarden?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  location?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  settlement?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  propertyAndGarden?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  rightsAndDuties?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  publicRelations?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  jointOwnership?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  jointStockOwnership?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  economy?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  various?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  buyRelations?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  extra?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
};

export type PropertyGeolocation = {
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  unit?: Maybe<PropertyGeolocationUnit>;
};

export enum PropertyGeolocationUnit {
  Km = 'km',
  M = 'm'
}

export type PropertyHasEstatePicker = {
  __typename?: 'PropertyHasEstatePicker';
  rt?: Maybe<Scalars['Boolean']>;
  external?: Maybe<Scalars['String']>;
};

export type PropertyHighlighted = {
  __typename?: 'PropertyHighlighted';
  type?: Maybe<Scalars['String']>;
};

export type PropertyHovedoppdrag = {
  __typename?: 'PropertyHovedoppdrag';
  id?: Maybe<Scalars['Int']>;
};

export type PropertyImages = {
  __typename?: 'PropertyImages';
  first?: Maybe<Image>;
  list?: Maybe<Array<Maybe<Image>>>;
  floorplan?: Maybe<Array<Maybe<Image>>>;
};

export type PropertyInput = {
  sguid: Scalars['String'];
  attachmentType?: Maybe<PropertyAttachmentType>;
  preview?: Maybe<Scalars['Boolean']>;
  /** Hent eiendommer som ikke er markedsføringsklare. */
  includeInactive?: Maybe<Scalars['Boolean']>;
  /** Hent eiendommer som er akseptert */
  includeAccepted?: Maybe<Scalars['Boolean']>;
  includeUnits?: Maybe<Scalars['Boolean']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  sold?: Maybe<Scalars['Boolean']>;
};

export type PropertyLink = {
  __typename?: 'PropertyLink';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PropertyLinks = {
  __typename?: 'PropertyLinks';
  list?: Maybe<Array<Maybe<PropertyLink>>>;
};

export type PropertyMatchekriterier = {
  __typename?: 'PropertyMatchekriterier';
  kriterier?: Maybe<Kriterier>;
};

export type PropertyMatrikkel = {
  __typename?: 'PropertyMatrikkel';
  info?: Maybe<Matrikkel>;
};

export type PropertyNeighborhood = {
  __typename?: 'PropertyNeighborhood';
  profile?: Maybe<NeighborhoodUrl>;
  list?: Maybe<Neighborhood>;
};

export type PropertyNybygg = {
  __typename?: 'PropertyNybygg';
  boligvelger?: Maybe<PropertyHasEstatePicker>;
  profile?: Maybe<Scalars['Int']>;
  showPriceList?: Maybe<Scalars['Boolean']>;
};

export type PropertyOffice = {
  __typename?: 'PropertyOffice';
  info?: Maybe<Office>;
};

export type PropertyPagination = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type PropertyParking = {
  __typename?: 'PropertyParking';
  list?: Maybe<Array<Maybe<ParkingElement>>>;
};

export type PropertyPlot = {
  __typename?: 'PropertyPlot';
  info?: Maybe<Plot>;
};

export type PropertyPrice = {
  __typename?: 'PropertyPrice';
  info?: Maybe<Price>;
};

export type PropertyProjectLogo = {
  __typename?: 'PropertyProjectLogo';
  id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
};

export type PropertyProjectLogos = {
  __typename?: 'PropertyProjectLogos';
  list?: Maybe<Array<Maybe<PropertyProjectLogo>>>;
};

export type PropertyProspect = {
  __typename?: 'PropertyProspect';
  info?: Maybe<PropertyProspectUrl>;
};

export type PropertyProspectUrl = {
  __typename?: 'PropertyProspectUrl';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum PropertySaleType {
  Nybygg = 'NYBYGG',
  Brukt = 'BRUKT',
  Fritid = 'FRITID',
  Fritidutleie = 'FRITIDUTLEIE',
  Naering = 'NAERING',
  Naeringutleie = 'NAERINGUTLEIE'
}

export type PropertySalgsoppgaveArkiv = {
  __typename?: 'PropertySalgsoppgaveArkiv';
  list?: Maybe<Array<Maybe<Document>>>;
};

export type PropertySearchLocationItem = {
  id?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<PropertySearchSubLocationItem>>>;
};

export type PropertySearchSubLocationItem = {
  id?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  municipalityArea?: Maybe<Scalars['String']>;
};

export enum PropertySortByType {
  Publishednewold = 'PUBLISHEDNEWOLD',
  Publishedoldnew = 'PUBLISHEDOLDNEW',
  Pricehighlow = 'PRICEHIGHLOW',
  Pricelowhigh = 'PRICELOWHIGH',
  Sizehighlow = 'SIZEHIGHLOW',
  Sizelowhigh = 'SIZELOWHIGH',
  Distanceasc = 'DISTANCEASC',
  Distancedesc = 'DISTANCEDESC',
  Viewingtoday = 'VIEWINGTODAY',
  Viewingtomorrow = 'VIEWINGTOMORROW',
  Viewingthisweek = 'VIEWINGTHISWEEK',
  Recentlysold = 'RECENTLYSOLD'
}

export type PropertyUnits = {
  __typename?: 'PropertyUnits';
  available?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  list?: Maybe<AllPropertyUnits>;
};

export type PropertyVideo = {
  __typename?: 'PropertyVideo';
  info?: Maybe<Media>;
};

export type PropertyViewings = {
  __typename?: 'PropertyViewings';
  list?: Maybe<Array<Maybe<View>>>;
};

export type Query = {
  __typename?: 'Query';
  getSamtykkeByUser?: Maybe<SamtykkeResponse>;
  getAvailableSamtykker?: Maybe<Array<Maybe<SamtykkeContainerResponse>>>;
  getAvailableSamtykkerByIds?: Maybe<Array<Maybe<SamtykkeContainerResponse>>>;
  boligsokByHash?: Maybe<Bs_BoligsokCriteria>;
  findMatchingSearches: Bs_MatchingSearchesOutput;
  getProperty?: Maybe<Property>;
  getProperties?: Maybe<Properties>;
  getOffice?: Maybe<Office>;
  getOffices?: Maybe<OfficeResponse>;
  getBroker?: Maybe<SingleBroker>;
  getBrokers?: Maybe<BrokersList>;
  search?: Maybe<SearchResult>;
  getAllCounties?: Maybe<SearchLocationsResult>;
  getMunicipalities?: Maybe<SearchLocationsResult>;
  getAllNews?: Maybe<AllNewsResponse>;
  getSingleNews?: Maybe<SingleNewsResponse>;
  landingpages?: Maybe<LandingpagesResponse>;
  getMenu?: Maybe<Menu>;
  getPosition?: Maybe<Position>;
  getPositions?: Maybe<GetPositionResponse>;
  getReferences?: Maybe<GetReferenceResponse>;
  leadServiceVersion?: Maybe<Scalars['String']>;
  getNdPageContent?: Maybe<PageContentItem>;
  getNdPageConfig?: Maybe<PageConfigItem>;
};


export type QueryGetAvailableSamtykkerByIdsArgs = {
  ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
};


export type QueryBoligsokByHashArgs = {
  hash?: Maybe<Scalars['String']>;
};


export type QueryFindMatchingSearchesArgs = {
  input: Bs_MatchingSearchesInput;
};


export type QueryGetPropertyArgs = {
  input?: Maybe<PropertyInput>;
};


export type QueryGetPropertiesArgs = {
  input?: Maybe<PropertiesInput>;
};


export type QueryGetOfficeArgs = {
  input?: Maybe<OfficeInput>;
};


export type QueryGetOfficesArgs = {
  input?: Maybe<OfficesInput>;
};


export type QueryGetBrokerArgs = {
  input?: Maybe<BrokerInput>;
};


export type QueryGetBrokersArgs = {
  input?: Maybe<BrokersInput>;
};


export type QuerySearchArgs = {
  input?: Maybe<SearchInput>;
};


export type QueryGetMunicipalitiesArgs = {
  counties?: Maybe<Array<Maybe<Scalars['String']>>>;
  useArea?: Maybe<Scalars['Boolean']>;
};


export type QueryGetAllNewsArgs = {
  input: GetAllNewsInput;
};


export type QueryGetSingleNewsArgs = {
  input: GetSingleNewsInput;
};


export type QueryLandingpagesArgs = {
  input?: Maybe<Landingpages>;
};


export type QueryGetPositionArgs = {
  input: GetPositionInput;
};


export type QueryGetPositionsArgs = {
  input: GetPositionsInput;
};


export type QueryGetReferencesArgs = {
  input: GetReferencesInput;
};

export type Reference = {
  __typename?: 'Reference';
  id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
};

export enum ReferenceType {
  Broker = 'BROKER',
  Office = 'OFFICE'
}

export type ReferencesPagination = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type Seo = {
  __typename?: 'SEO';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type Samtykke = {
  __typename?: 'Samtykke';
  id?: Maybe<Scalars['Int']>;
  samtykke?: Maybe<Scalars['String']>;
  beskrivelse?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
};

export type SamtykkeContainerResponse = {
  __typename?: 'SamtykkeContainerResponse';
  id?: Maybe<Scalars['Int']>;
  samtykketekst?: Maybe<Scalars['String']>;
  varighetmnd?: Maybe<Scalars['Int']>;
  samtykker?: Maybe<Array<Maybe<Samtykke>>>;
};

export type SamtykkeInput = {
  text?: Maybe<Scalars['String']>;
  varighet?: Maybe<Scalars['Int']>;
};

export type SamtykkeResponse = {
  __typename?: 'SamtykkeResponse';
  user?: Maybe<Scalars['String']>;
  samtykker?: Maybe<Array<Maybe<Samtykke>>>;
};

export type SaveDiggerInput = {
  type?: Maybe<FormType>;
  id?: Maybe<Scalars['String']>;
  diggerId?: Maybe<Scalars['String']>;
  diggerIds?: Maybe<Array<Maybe<DiggerId>>>;
};

export type SearchBroker = {
  __typename?: 'SearchBroker';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  cellphone?: Maybe<Scalars['String']>;
  image?: Maybe<BrokerImage>;
  path?: Maybe<Scalars['String']>;
  office?: Maybe<Array<Maybe<Office>>>;
  naering?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type SearchChecklistPoints = {
  __typename?: 'SearchChecklistPoints';
  pmExclusive?: Maybe<Scalars['Boolean']>;
  useScaledVersion?: Maybe<Scalars['Boolean']>;
  teaser?: Maybe<Scalars['Boolean']>;
  dobbeltBoligforsikring?: Maybe<Scalars['Boolean']>;
};

export type SearchChecklistPointsInfo = {
  __typename?: 'SearchChecklistPointsInfo';
  info?: Maybe<SearchChecklistPoints>;
};

export type SearchInput = {
  searchIn: Array<Maybe<SearchInputType>>;
  query?: Maybe<Scalars['String']>;
  filter?: Maybe<Filter>;
};

export type SearchInputType = {
  type: SearchTypes;
  pagination: SearchPagination;
};

export type SearchLocationsResult = {
  __typename?: 'SearchLocationsResult';
  list?: Maybe<Array<Maybe<AggregatedItem>>>;
};

export type SearchPagination = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type SearchProperty = {
  __typename?: 'SearchProperty';
  preview?: Maybe<Scalars['Boolean']>;
  previewUpdated?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  /** Prosjekt in webmegler_object_cache */
  title?: Maybe<Scalars['String']>;
  /** Overskrift in webmegler_object_cache */
  description?: Maybe<Scalars['String']>;
  freetext?: Maybe<PropertyFreeText>;
  /**
   * Type oppdrag
   * (1 = nybygg, 2 = brukt og 3 = fritid)
   */
  permalink?: Maybe<Scalars['String']>;
  assignmentType?: Maybe<Scalars['String']>;
  ownerType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  naering?: Maybe<Scalars['Boolean']>;
  typeNumber?: Maybe<Scalars['Int']>;
  buildYear?: Maybe<Scalars['String']>;
  rooms?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Scalars['Int']>;
  floor?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Boolean']>;
  bid?: Maybe<PropertyBid>;
  area?: Maybe<PropertyArea>;
  plot?: Maybe<PropertyPlot>;
  price?: Maybe<PropertyPrice>;
  viewings?: Maybe<PropertyViewings>;
  units?: Maybe<PropertyUnits>;
  location?: Maybe<Location>;
  brokers?: Maybe<PropertyAgents>;
  images?: Maybe<SearchPropertyImages>;
  environment?: Maybe<PropertyEnvironment>;
  matrikkel?: Maybe<PropertyMatrikkel>;
  neighborhood?: Maybe<PropertyNeighborhood>;
  documents?: Maybe<PropertyDocuments>;
  links?: Maybe<PropertyLinks>;
  office?: Maybe<PropertyOffice>;
  checklistpoints?: Maybe<SearchChecklistPointsInfo>;
  video?: Maybe<PropertyVideo>;
  viewing3d?: Maybe<Property3dViewing>;
  highlighted?: Maybe<Array<Maybe<PropertyHighlighted>>>;
  created?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedDate?: Maybe<Scalars['String']>;
};

export type SearchPropertyImage = {
  __typename?: 'SearchPropertyImage';
  url?: Maybe<Scalars['String']>;
};

export type SearchPropertyImages = {
  __typename?: 'SearchPropertyImages';
  first?: Maybe<SearchPropertyImage>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  result?: Maybe<SearchResultSub>;
};

export type SearchResultBrokers = {
  __typename?: 'SearchResultBrokers';
  total?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<SearchBroker>>>;
};

export type SearchResultLandingpages = {
  __typename?: 'SearchResultLandingpages';
  total?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SearchResultOffices = {
  __typename?: 'SearchResultOffices';
  total?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Office>>>;
};

export type SearchResultProperties = {
  __typename?: 'SearchResultProperties';
  total?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<SearchProperty>>>;
  aggregations?: Maybe<PropertyAggregations>;
};

export type SearchResultSub = {
  __typename?: 'SearchResultSub';
  properties?: Maybe<SearchResultProperties>;
  offices?: Maybe<SearchResultOffices>;
  brokers?: Maybe<SearchResultBrokers>;
  landingpages?: Maybe<SearchResultLandingpages>;
};

export enum SearchTypes {
  Property = 'property',
  Broker = 'broker',
  Office = 'office',
  Landingpage = 'landingpage'
}

export type SingleBroker = {
  __typename?: 'SingleBroker';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  cellphone?: Maybe<Scalars['String']>;
  image?: Maybe<BrokerImage>;
  path?: Maybe<Scalars['String']>;
  helper?: Maybe<Scalars['Boolean']>;
  offices?: Maybe<BrokerOffices>;
  properties?: Maybe<BrokerShowProperties>;
  naering?: Maybe<Scalars['Boolean']>;
};

export type SingleNewsResponse = {
  __typename?: 'SingleNewsResponse';
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imageCategory?: Maybe<Scalars['String']>;
  imageDescriptionTop?: Maybe<Scalars['String']>;
  imageDescriptionBottom?: Maybe<Scalars['String']>;
  ingress?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['String']>;
};

export type SoldpriceResponse = {
  __typename?: 'SoldpriceResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type StandardResponse = {
  __typename?: 'StandardResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateNewsResponse = {
  __typename?: 'UpdateNewsResponse';
  id?: Maybe<Scalars['Int']>;
};

export type UpdatePropertyHighLighted = {
  __typename?: 'UpdatePropertyHighLighted';
  id?: Maybe<Scalars['Int']>;
};

export type ValuationResponse = {
  __typename?: 'ValuationResponse';
  success?: Maybe<Scalars['Boolean']>;
  /** Lead data for digger */
  data?: Maybe<DiggerData>;
};

export type View = {
  __typename?: 'View';
  id?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  startDateTime?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['String']>;
};

export type WmKriterier = {
  __typename?: 'WMKriterier';
  nr?: Maybe<Scalars['Int']>;
  id_typer?: Maybe<Scalars['Int']>;
  navn?: Maybe<Scalars['String']>;
};

//Articles

export type ArticleEditInput = {
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  ingress: Maybe<Scalars['String']>;
  body: Scalars['String'];
  urltag: Scalars['String'];
  category: Scalars['Int'];
  publish: Scalars['Boolean'];
};

//PageContent
export type QueryGetPageContentInputArgs = {
  input?: Maybe<PageContentInput>;
};

export type PageContentInput = {
  urltag?: Maybe<Scalars['String']>;
  type?: Maybe<PageContentType>;
};

export type PageContentItem = {
  __typename?: 'PageContentItem';
  title?: Maybe<Scalars['String']>;
  ingress?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imageList: Maybe<Array<Maybe<PageContentImage>>>
  office?: Maybe<PageContentOfficeItem>;
  seo?: Maybe<SeoItem>;
  config?: Maybe<PageConfigItem>;
};

export type QueryGetPageConfigInputArgs = {
  input?: Maybe<PageConfigInput>;
};

export type PageConfigInput = {
  urltag?: Maybe<Scalars['String']>;
};

export type PageConfigItem = {
  __typename?: 'PageConfigItem';
  showStatistics?: Maybe<Scalars['Boolean']>;
  showSubpageNews?: Maybe<Scalars['Boolean']>;
  showSubpageServices?: Maybe<Scalars['Boolean']>;
  showSubpageContact?: Maybe<Scalars['Boolean']>;
  showSubpageProperties?: Maybe<Scalars['Boolean']>;
  showSubpagePropertiesHighlight?: Maybe<Scalars['Boolean']>;
  showFrontpageNews?: Maybe<Scalars['Boolean']>;
  showFrontpageService?: Maybe<Scalars['Boolean']>;
}

export type PageContentOfficeItem = {
  __typename?: 'PageContentOfficeItem';
  name?: Maybe<Scalars['String']>;
  urltag?: Maybe<Scalars['String']>;
}

export type SeoItem = {
  __typename?: 'PageContentItem';
  title?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
}

export type PageContentImage = {
  __typename?: 'PageContentImage';
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  linkTo?: Maybe<Scalars['String']>;
}